module.exports = __webpack_public_path__ + "h5/img/hb1-0.ccc985c7.png";